export const COUNTRY_OPTIONS = [
	{ name: "Afghanistan", dialCodes: ["93"] },
	{ name: "Aland Islands", dialCodes: ["358"] },
	{ name: "Albania", dialCodes: ["355"] },
	{ name: "Algeria", dialCodes: ["213"] },
	{ name: "American Samoa", dialCodes: ["1684"] },
	{ name: "Andorra", dialCodes: ["376"] },
	{ name: "Angola", dialCodes: ["244"] },
	{ name: "Anguilla", dialCodes: ["1264"] },
	{ name: "Antarctica", dialCodes: ["672"] },
	{ name: "Antigua and Barbuda", dialCodes: ["1268"] },
	{ name: "Argentina", dialCodes: ["54"] },
	{ name: "Armenia", dialCodes: ["374"] },
	{ name: "Aruba", dialCodes: ["297"] },
	{ name: "Australia", dialCodes: ["61"] },
	{ name: "Austria", dialCodes: ["43"] },
	{ name: "Azerbaijan", dialCodes: ["994"] },
	{ name: "Bahamas", dialCodes: ["1242"] },
	{ name: "Bahrain", dialCodes: ["973"] },
	{ name: "Bangladesh", dialCodes: ["880"] },
	{ name: "Barbados", dialCodes: ["1246"] },
	{ name: "Belarus", dialCodes: ["375"] },
	{ name: "Belgium", dialCodes: ["32"] },
	{ name: "Belize", dialCodes: ["501"] },
	{ name: "Benin", dialCodes: ["229"] },
	{ name: "Bermuda", dialCodes: ["1441"] },
	{ name: "Bhutan", dialCodes: ["975"] },
	{ name: "Bolivia", dialCodes: ["591"] },
	{ name: "Bonaire, Sint Eustatius and Saba", dialCodes: ["599"] },
	{ name: "Bosnia and Herzegovina", dialCodes: ["387"] },
	{ name: "Botswana", dialCodes: ["267"] },
	{ name: "Bouvet Island", dialCodes: ["47"] },
	{ name: "Brazil", dialCodes: ["55"] },
	{ name: "British Indian Ocean Territory", dialCodes: ["246"] },
	{ name: "British Virgin Islands", dialCodes: ["1284"] },
	{ name: "Brunei", dialCodes: ["673"] },
	{ name: "Bulgaria", dialCodes: ["359"] },
	{ name: "Burkina Faso", dialCodes: ["226"] },
	{ name: "Burundi", dialCodes: ["257"] },
	{ name: "Cambodia", dialCodes: ["855"] },
	{ name: "Cameroon", dialCodes: ["237"] },
	{ name: "Canada", dialCodes: ["1"] },
	{ name: "Cape Verde", dialCodes: ["238"] },
	{ name: "Cayman Islands", dialCodes: ["1345"] },
	{ name: "Central African Republic", dialCodes: ["236"] },
	{ name: "Chad", dialCodes: ["235"] },
	{ name: "Chile", dialCodes: ["56"] },
	{ name: "China", dialCodes: ["86"] },
	{ name: "Christmas Island", dialCodes: ["61"] },
	{ name: "Cocos (Keeling) Islands", dialCodes: ["61"] },
	{ name: "Colombia", dialCodes: ["57"] },
	{ name: "Comoros", dialCodes: ["269"] },
	{ name: "Congo - Brazzaville", dialCodes: ["242"] },
	{ name: "Congo - Kinshasa", dialCodes: ["243"] },
	{ name: "Cook Islands", dialCodes: ["682"] },
	{ name: "Costa Rica", dialCodes: ["506"] },
	{ name: "Cote d'Ivoire", dialCodes: ["225"] },
	{ name: "Croatia", dialCodes: ["385"] },
	{ name: "Cuba", dialCodes: ["53"] },
	{ name: "Curacao", dialCodes: ["599"] },
	{ name: "Cyprus", dialCodes: ["357"] },
	{ name: "Czechia", dialCodes: ["420"] },
	{ name: "Denmark", dialCodes: ["45"] },
	{ name: "Djibouti", dialCodes: ["253"] },
	{ name: "Dominica", dialCodes: ["1767"] },
	{ name: "Dominican Republic", dialCodes: ["1809", "1829", "1849"] },
	{ name: "Ecuador", dialCodes: ["593"] },
	{ name: "Egypt", dialCodes: ["20"] },
	{ name: "El Salvador", dialCodes: ["503"] },
	{ name: "Equatorial Guinea", dialCodes: ["240"] },
	{ name: "Eritrea", dialCodes: ["291"] },
	{ name: "Estonia", dialCodes: ["372"] },
	{ name: "Eswatini", dialCodes: ["268"] },
	{ name: "Ethiopia", dialCodes: ["251"] },
	{ name: "Falkland Islands", dialCodes: ["500"] },
	{ name: "Faroe Islands", dialCodes: ["298"] },
	{ name: "Fiji", dialCodes: ["679"] },
	{ name: "Finland", dialCodes: ["358"] },
	{ name: "France", dialCodes: ["33"] },
	{ name: "French Guiana", dialCodes: ["594"] },
	{ name: "French Polynesia", dialCodes: ["689"] },
	{ name: "French Southern Territories", dialCodes: ["262"] },
	{ name: "Gabon", dialCodes: ["241"] },
	{ name: "Gambia", dialCodes: ["220"] },
	{ name: "Georgia", dialCodes: ["995"] },
	{ name: "Germany", dialCodes: ["49"] },
	{ name: "Ghana", dialCodes: ["233"] },
	{ name: "Gibraltar", dialCodes: ["350"] },
	{ name: "Greece", dialCodes: ["30"] },
	{ name: "Greenland", dialCodes: ["299"] },
	{ name: "Grenada", dialCodes: ["1473"] },
	{ name: "Guadeloupe", dialCodes: ["590"] },
	{ name: "Guam", dialCodes: ["1671"] },
	{ name: "Guatemala", dialCodes: ["502"] },
	{ name: "Guernsey", dialCodes: ["44"] },
	{ name: "Guinea", dialCodes: ["224"] },
	{ name: "Guinea-Bissau", dialCodes: ["245"] },
	{ name: "Guyana", dialCodes: ["592"] },
	{ name: "Haiti", dialCodes: ["509"] },
	{ name: "Heard Island and McDonald Islands", dialCodes: ["672"] },
	{ name: "Honduras", dialCodes: ["504"] },
	{ name: "Hong Kong", dialCodes: ["852"] },
	{ name: "Hungary", dialCodes: ["36"] },
	{ name: "Iceland", dialCodes: ["354"] },
	{ name: "India", dialCodes: ["91"] },
	{ name: "Indonesia", dialCodes: ["62"] },
	{ name: "Iran", dialCodes: ["98"] },
	{ name: "Iraq", dialCodes: ["964"] },
	{ name: "Ireland", dialCodes: ["353"] },
	{ name: "Isle of Man", dialCodes: ["44"] },
	{ name: "Israel", dialCodes: ["972"] },
	{ name: "Italy", dialCodes: ["39"] },
	{ name: "Jamaica", dialCodes: ["1876", "1658"] },
	{ name: "Japan", dialCodes: ["81"] },
	{ name: "Jersey", dialCodes: ["44"] },
	{ name: "Jordan", dialCodes: ["962"] },
	{ name: "Kazakhstan", dialCodes: ["7"] },
	{ name: "Kenya", dialCodes: ["254"] },
	{ name: "Kiribati", dialCodes: ["686"] },
	{ name: "Kosovo", dialCodes: ["383"] },
	{ name: "Kuwait", dialCodes: ["965"] },
	{ name: "Kyrgyzstan", dialCodes: ["996"] },
	{ name: "Laos", dialCodes: ["856"] },
	{ name: "Latvia", dialCodes: ["371"] },
	{ name: "Lebanon", dialCodes: ["961"] },
	{ name: "Lesotho", dialCodes: ["266"] },
	{ name: "Liberia", dialCodes: ["231"] },
	{ name: "Libya", dialCodes: ["218"] },
	{ name: "Liechtenstein", dialCodes: ["423"] },
	{ name: "Lithuania", dialCodes: ["370"] },
	{ name: "Luxembourg", dialCodes: ["352"] },
	{ name: "Macao", dialCodes: ["853"] },
	{ name: "Madagascar", dialCodes: ["261"] },
	{ name: "Malawi", dialCodes: ["265"] },
	{ name: "Malaysia", dialCodes: ["60"] },
	{ name: "Maldives", dialCodes: ["960"] },
	{ name: "Mali", dialCodes: ["223"] },
	{ name: "Malta", dialCodes: ["356"] },
	{ name: "Marshall Islands", dialCodes: ["692"] },
	{ name: "Martinique", dialCodes: ["596"] },
	{ name: "Mauritania", dialCodes: ["222"] },
	{ name: "Mauritius", dialCodes: ["230"] },
	{ name: "Mayotte", dialCodes: ["262"] },
	{ name: "Mexico", dialCodes: ["52"] },
	{ name: "Micronesia", dialCodes: ["691"] },
	{ name: "Moldova", dialCodes: ["373"] },
	{ name: "Monaco", dialCodes: ["377"] },
	{ name: "Mongolia", dialCodes: ["976"] },
	{ name: "Montenegro", dialCodes: ["382"] },
	{ name: "Montserrat", dialCodes: ["1664"] },
	{ name: "Morocco", dialCodes: ["212"] },
	{ name: "Mozambique", dialCodes: ["258"] },
	{ name: "Myanmar", dialCodes: ["95"] },
	{ name: "Namibia", dialCodes: ["264"] },
	{ name: "Nauru", dialCodes: ["674"] },
	{ name: "Nepal", dialCodes: ["977"] },
	{ name: "Netherlands", dialCodes: ["31"] },
	{ name: "New Caledonia", dialCodes: ["687"] },
	{ name: "New Zealand", dialCodes: ["64"] },
	{ name: "Nicaragua", dialCodes: ["505"] },
	{ name: "Niger", dialCodes: ["227"] },
	{ name: "Nigeria", dialCodes: ["234"] },
	{ name: "Niue", dialCodes: ["683"] },
	{ name: "Norfolk Island", dialCodes: ["672"] },
	{ name: "North Korea", dialCodes: ["850"] },
	{ name: "North Macedonia", dialCodes: ["389"] },
	{ name: "Northern Mariana Islands", dialCodes: ["1670"] },
	{ name: "Norway", dialCodes: ["47"] },
	{ name: "Oman", dialCodes: ["968"] },
	{ name: "Pakistan", dialCodes: ["92"] },
	{ name: "Palau", dialCodes: ["680"] },
	{ name: "Palestinian Territories", dialCodes: ["970"] },
	{ name: "Panama", dialCodes: ["507"] },
	{ name: "Papua New Guinea", dialCodes: ["675"] },
	{ name: "Paraguay", dialCodes: ["595"] },
	{ name: "Peru", dialCodes: ["51"] },
	{ name: "Philippines", dialCodes: ["63"] },
	{ name: "Pitcairn Islands", dialCodes: ["64"] },
	{ name: "Poland", dialCodes: ["48"] },
	{ name: "Portugal", dialCodes: ["351"] },
	{ name: "Puerto Rico", dialCodes: ["1787", "1939"] },
	{ name: "Qatar", dialCodes: ["974"] },
	{ name: "Reunion", dialCodes: ["262"] },
	{ name: "Romania", dialCodes: ["40"] },
	{ name: "Russia", dialCodes: ["7"] },
	{ name: "Rwanda", dialCodes: ["250"] },
	{ name: "Saint Barthelemy", dialCodes: ["590"] },
	{ name: "Saint Helena, Ascension and Tristan da Cunha", dialCodes: ["290"] },
	{ name: "Saint Kitts and Nevis", dialCodes: ["1869"] },
	{ name: "Saint Lucia", dialCodes: ["1758"] },
	{ name: "Saint Martin", dialCodes: ["590"] },
	{ name: "Saint Pierre and Miquelon", dialCodes: ["508"] },
	{ name: "Saint Vincent and the Grenadines", dialCodes: ["1784"] },
	{ name: "Samoa", dialCodes: ["685"] },
	{ name: "San Marino", dialCodes: ["378"] },
	{ name: "Sao Tome and Principe", dialCodes: ["239"] },
	{ name: "Saudi Arabia", dialCodes: ["966"] },
	{ name: "Senegal", dialCodes: ["221"] },
	{ name: "Serbia", dialCodes: ["381"] },
	{ name: "Seychelles", dialCodes: ["248"] },
	{ name: "Sierra Leone", dialCodes: ["232"] },
	{ name: "Singapore", dialCodes: ["65"] },
	{ name: "Sint Maarten", dialCodes: ["1721"] },
	{ name: "Slovakia", dialCodes: ["421"] },
	{ name: "Slovenia", dialCodes: ["386"] },
	{ name: "Solomon Islands", dialCodes: ["677"] },
	{ name: "Somalia", dialCodes: ["252"] },
	{ name: "South Africa", dialCodes: ["27"] },
	{ name: "South Georgia and the South Sandwich Islands", dialCodes: ["500"] },
	{ name: "South Korea", dialCodes: ["82"] },
	{ name: "South Sudan", dialCodes: ["211"] },
	{ name: "Spain", dialCodes: ["34"] },
	{ name: "Sri Lanka", dialCodes: ["94"] },
	{ name: "Sudan", dialCodes: ["249"] },
	{ name: "Suriname", dialCodes: ["597"] },
	{ name: "Svalbard and Jan Mayen", dialCodes: ["47"] },
	{ name: "Sweden", dialCodes: ["46"] },
	{ name: "Switzerland", dialCodes: ["41"] },
	{ name: "Syria", dialCodes: ["963"] },
	{ name: "Taiwan", dialCodes: ["886"] },
	{ name: "Tajikistan", dialCodes: ["992"] },
	{ name: "Tanzania", dialCodes: ["255"] },
	{ name: "Thailand", dialCodes: ["66"] },
	{ name: "Timor-Leste", dialCodes: ["670"] },
	{ name: "Togo", dialCodes: ["228"] },
	{ name: "Tokelau", dialCodes: ["690"] },
	{ name: "Tonga", dialCodes: ["676"] },
	{ name: "Trinidad and Tobago", dialCodes: ["1868"] },
	{ name: "Tunisia", dialCodes: ["216"] },
	{ name: "Turkey", dialCodes: ["90"] },
	{ name: "Turkmenistan", dialCodes: ["993"] },
	{ name: "Turks and Caicos Islands", dialCodes: ["1649"] },
	{ name: "Tuvalu", dialCodes: ["688"] },
	{ name: "U.S. Outlying Islands", dialCodes: ["1"] },
	{ name: "U.S. Virgin Islands", dialCodes: ["1340"] },
	{ name: "Uganda", dialCodes: ["256"] },
	{ name: "Ukraine", dialCodes: ["380"] },
	{ name: "United Arab Emirates", dialCodes: ["971"] },
	{ name: "United Kingdom", dialCodes: ["44"] },
	{ name: "United States", dialCodes: ["1"] },
	{ name: "Uruguay", dialCodes: ["598"] },
	{ name: "Uzbekistan", dialCodes: ["998"] },
	{ name: "Vanuatu", dialCodes: ["678"] },
	{ name: "Vatican City", dialCodes: ["39"] },
	{ name: "Venezuela", dialCodes: ["58"] },
	{ name: "Vietnam", dialCodes: ["84"] },
	{ name: "Wallis and Futuna", dialCodes: ["681"] },
	{ name: "Western Sahara", dialCodes: ["212"] },
	{ name: "Yemen", dialCodes: ["967"] },
	{ name: "Zambia", dialCodes: ["260"] },
	{ name: "Zimbabwe", dialCodes: ["263"] },
] as const;

export const DEFAULT_COUNTRY = "United States";

const DIAL_CODES = new Map<string, readonly string[]>(
	COUNTRY_OPTIONS.map((country) => [country.name, country.dialCodes]),
);

/** Digits without the `+`, the country's original code first. Territories that share `+1` list their area codes. */
export function countryDialCodes(countryName: string): readonly string[] {
	return DIAL_CODES.get(countryName) ?? [];
}

export function countryLabel(countryName: string): string {
	return `${countryName} (+${countryDialCodes(countryName).join(", ")})`;
}
